<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="标签名称" prop="name">
            <el-input v-model="query.tagName" placeholder="请输入标签名称" size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.tagStatus" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新增标签</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="标签组" prop="name" align="center" fixed width="200">
          <template slot-scope="{row}">
            {{row.customerTagGroup.groupName}}
          </template>
        </el-table-column>
        <el-table-column label="标签名称" prop="name" align="center" fixed>
          <template slot-scope="{row}">
            <el-tag v-for="item in row.customerTagList" :key="item.id" style="margin: 0 4px 4px 0;">{{item.name}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime" sortable="custom" align="center" fixed width="170">
          <template slot-scope="{row}">
            {{row.customerTagGroup.createdTime}}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" fixed width="170">
          <template slot-scope="{row}">
            {{row.customerTagGroup.operatedTime}}
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operatedName" align="center" width="120">
          <template slot-scope="{row}">
            {{row.customerTagGroup.operatedByName}}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="state" align="center" width="120">
          <template slot-scope="{row}">
            <el-switch v-model="row.customerTagGroup.tagStatus" :active-value="1" :inactive-value="0" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="170">
          <template slot-scope="{row}"  >
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
            <!-- <el-button type="text" @click="">日志记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <banner-add ref="bannerAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import bannerAdd from './add'
import clientLabelApi from '@/api/client/label'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    bannerAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      selectItems: [],
      activeName: '1'
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 分类筛选
     */
    handleClick(){
      this.doQueryList({ pageNo: 1 })
      // console.log("activeName: ",this.activeName);
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
    handleFilter(){
      this.query={
        pageNo: 1,
        pageSize: 10
      }
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return clientLabelApi.fetchNewList(this.query)
        .then(({data}) => {
          console.log("data: ",data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => clientLabelApi.deleteBatch([row.customerTagGroup.id]))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm(`当前选择${this.selectItems.length}条数据，是否确认删除`)
        .then(() => clientLabelApi.deleteBatch(this.selectItems.map(row => row.customerTagGroup.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 状态修改
     */
    changeSwitch(row) {
      console.log('row',row)
      let obj={
        id:row.customerTagGroup.id,
        tagStatus: row.customerTagGroup.tagStatus,
        groupName:row.customerTagGroup.groupName
      }
      obj.tagUpdateDTOList=row.customerTagList.map(i=>({id:i.id,groupId:row.customerTagGroup.id,name:i.name,tagState:row.customerTagGroup.tagStatus}))
      // return
      clientLabelApi.create({ ...obj }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.bannerAdd.handleCreate()
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.bannerShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.bannerAdd.handleUpdate(row)
    }
  }
}
</script>
